import React, { useEffect, useState } from "react";

import { ClubNavigator } from "./ClubNavigator";
import { Events } from "../screens/Events";

import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import { TabBar } from "../components/TabBar";
import { useAtom, useAtomValue } from "jotai";
import * as Device from "expo-device";
import * as Notifications from "expo-notifications";
import Constants from "expo-constants";
import {
  currentTripAtom,
  currentUserAtom,
  showTripBannerAtom,
} from "../../atoms/global";
import { supabase } from "../../lib/supabase";
import {
  BcIcon,
  BikeIcon,
  EggIcon,
  PeopleIcon,
} from "../components/design-system/icons";
import { ProfileNavigator } from "./ProfileNavigator";
import { Platform } from "react-native";
import { RidesNavigator } from "./RidesNavigator";
import { TripNavigator } from "./TripNavigator";
import { TripIcon } from "../components/TripIcon";
import { Text, View, XStack } from "tamagui";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { ArrowRightIcon } from "../components/design-system/icons/ArrowRightIcon";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Pressable } from "react-native";
import { NavigationProp, useNavigation } from "@react-navigation/native";

async function registerForPushNotificationsAsync() {
  let token;

  if (Device.isDevice) {
    const { status: existingStatus } =
      await Notifications.getPermissionsAsync();
    let finalStatus = existingStatus;
    if (existingStatus !== "granted") {
      const { status } = await Notifications.requestPermissionsAsync();
      finalStatus = status;
    }
    if (finalStatus !== "granted") {
      // alert("Failed to get push token for push notification!");
      return;
    }
    token = await Notifications.getExpoPushTokenAsync({
      projectId: Constants?.expoConfig?.extra?.eas?.projectId ?? "",
    });
  }

  return token?.data ?? null;
}

export type HomeTabsParamList = {
  rides: undefined;
  events: undefined;
  club: undefined;
  profileTab: undefined;
  calendar: undefined;
  trip: { tripId: string; screen?: string };
};

const Tab = createMaterialTopTabNavigator<HomeTabsParamList>();

export const HomeTabsNavigator = () => {
  const user = useAtomValue(currentUserAtom);

  const setExpoPushToken = async (push_token: string | null) => {
    if (!user) throw new Error("No user on the session!");

    const { error } = await supabase
      .from("profiles")
      .update({ push_token })
      .eq("id", user.id);

    if (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (Platform.OS !== "web") {
      registerForPushNotificationsAsync().then((token) =>
        setExpoPushToken(token ?? "")
      );
    }
  }, []);

  // const [currentTrip, setCurrentTrip] = useAtom(currentTripAtom);

  const [showTripBanner, setShowTripBanner] = useAtom(showTripBannerAtom);
  const navigation = useNavigation<NavigationProp<HomeTabsParamList>>();

  // useEffect(() => {
  //   AsyncStorage.getItem("hasSeenTripModal").then((value) => {
  //     if (value !== "true" && currentTrip) {
  //       setShowTripBanner(true);
  //       navigation.navigate("trip", {
  //         tripId: `${currentTrip.id}`,
  //         screen: "TripDrawer",
  //       });
  //     }
  //   });
  // }, [currentTrip]);

  // useEffect(() => {
  //   const fetchCurrentTrip = async () => {
  //     const { data } = await supabase
  //       .from("attendances")
  //       .select("*, trip:trips(*)")
  //       .eq("user_id", user?.id)
  //       .not("trip_id", "is", null)
  //       .single();

  //     if (data && data.trip) {
  //       setCurrentTrip(data.trip);
  //     }
  //   };

  //   fetchCurrentTrip();
  // }, []);

  return (
    <>
      <Tab.Navigator
        tabBarPosition="bottom"
        tabBar={(props) => <TabBar {...props} />}
        screenOptions={{
          tabBarInactiveTintColor: "gray",
          tabBarActiveTintColor: "black",

          tabBarLabelStyle: {
            fontFamily: "Body",
            fontSize: 10,
          },
        }}
        initialRouteName="events"
      >
        <Tab.Screen
          component={Events}
          name="events"
          options={{
            title: "Events",
            tabBarIcon: ({ color }) => (
              <BcIcon width={25} height={25} color={color} />
            ),
          }}
        />

        <Tab.Screen
          component={RidesNavigator}
          name="rides"
          options={{
            title: "Rides",
            tabBarIcon: ({ color }) => (
              <BikeIcon
                strokeWidth={1}
                color={color}
                width={Platform.OS === "web" ? 25 : 30}
                height={25}
              />
            ),
          }}
        />
        <Tab.Screen
          name="club"
          component={ClubNavigator}
          options={{
            title: "Club",
            tabBarIcon: ({ color }) => (
              <EggIcon height={25} width={27} color={color} />
            ),
          }}
        />
        <Tab.Screen
          name="profileTab"
          component={ProfileNavigator}
          options={{
            title: "Profile",
            tabBarIcon: ({ color }) => (
              <PeopleIcon height={25} width={25} color={color} />
            ),
          }}
        />
        {/* {currentTrip ? (
          <Tab.Screen
            name="trip"
            component={TripNavigator}
            initialParams={{ tripId: `${currentTrip?.id ?? 1}` }}
            options={{
              title: currentTrip?.name ?? "Trip",
              tabBarIcon: () =>
                currentTrip?.image ? (
                  <TripIcon imageUrl={currentTrip?.image} />
                ) : (
                  <View bg="black" width={25} height={25} />
                ),
            }}
          />
        ) : null} */}
      </Tab.Navigator>
    </>
  );
};
